const EntityPermission = {

    // FIELDS
    "user_role": "User Role",
    "type": "Type",
    "type_option": "Type Option",
    "search": "Search",

    // PAGE HEADER
    "entity_permission": "Entity Permission",

    // ERROR
    "error_user_role": "Select User Role",
    "error_type": "Select Type",
    "error_type_option": "Select Type Option",

    // TABLE HEADER
    "table_user_role": 'USER ROLE',
    "table_type": "TYPE",
    "table_type_option": "TYPE OPTION",

}

export default EntityPermission;